export default "__VITE_ASSET__DGp0901z__"